module.exports = __webpack_public_path__ + "img/upload_wall_1.e1ecdd63.webp";